import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {ErrorResponse} from 'src/app/api/model/common/error-response.model';
import {EmailContactService} from 'src/app/api/module/erp/services/email/email-contact-service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TipoSeguros} from 'src/app/api/module/portal/enumerable/tipo-seguro-enumerable';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
import {CaptchaComponent} from 'src/app/pages/area-logada/shared/components/captcha/captcha.component';

@Component({
  selector: 'app-landing-page-seguros',
  templateUrl: './landing-page-seguros.component.html',
  styleUrls: ['./landing-page-seguros.component.scss'],
})
export class LandingPageSegurosComponent implements OnInit {
  blockTemplate: BlockTemplateComponent | undefined;
  scroll: any = 1;
  formGroupEmailContact!: UntypedFormGroup;
  isLoading: boolean = false;
  formSubmitted: boolean = false;
  isSendEmail: boolean = true;
  tiposSeguros = TipoSeguros;
  urlFrame: string = '';
  whatsApp: any =
    'https://api.whatsapp.com/send?phone=5511994766124&text=Olá, tudo bem? Vim através do portal de seguros.';
  descricaoRodapeCard: any =
    '*Preços de referência simulados considerando coberturas básicos, podendo o preço variar  conforme perfil do usuário e coberturas selecionadas';
  facaSuaCotacao: any = 'Faça sua cotação!';
  ApartirDe: any = 'A partir de';
  protecaoResidencia: any = 'Proteção e assistência para sua residência.';
  parcelas: any = 'em 12 parcelas';
  captchaToken: string | null = null;
  @ViewChild('captcha') captcha: CaptchaComponent;

  constructor(
    private router: Router,
    private emailContactService: EmailContactService,
    private toastr: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private _spinnerService: SpinnerService,
  ) {}

  ngOnInit(): void {
    this.formGroupEmailContact = this.formBuilder.group({
      name: ['', Validators.required, Validators.maxLength(50)],
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}$'),
      ]),
      phone: ['', [Validators.maxLength(14)]],
      message: ['', [Validators.required, Validators.maxLength(150)]],
    });
  }

  isFormValid() {
    this.formSubmitted = true;
    return this.formGroupEmailContact.invalid;
  }

  onSubmit() {
    if (!this.captchaToken) {
      this.toastr.error('Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      return;
    }
    if (this.isFormValid()) {
      return;
    }

    try {
      this.iniciarSpinner();
      this.isSendEmail = false;
      this.isLoading = true;
      this.emailContactService
        .onSendEmailComplice(this.formGroupEmailContact.value, this.captchaToken)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe(
          () => {
            this.captcha.reset();
            this.captchaToken = null;
            this.toastr.success('E-mail enviado!', 'Sucesso');
            this.formGroupEmailContact.reset();
            this.isLoading = false;
            this.formSubmitted = false;
          },

          (erro: ErrorResponse) => {
            this.toastr.error('Não foi possível enviar o e-mail.', 'Aviso!');
            this.pararSpinner();
            this.isLoading = false;
          },
        );
    } catch (error) {
      this.captcha.reset();
      this.captchaToken = null;
      this.pararSpinner();
      this.isLoading = false;
      this.toastr.error('Não foi possível enviar o E-mail, estamos trabalhando resolver a instabilidade', 'Aviso');
    }
  }

  navigateToSection(sectionId: any): void {
    this.iniciarSpinner();
    const marginTop = 114;
    let selector = document.querySelector('#' + sectionId);
    if (selector !== null) {
      this.goSection(sectionId, selector, marginTop);
    }
    //no primeiro click náo estava funcionando, ou seja náo estva sendo redirecionado, razao pela qual inseri o timer
    setTimeout(() => {
      if (selector !== null) {
        this.goSection(sectionId, selector, marginTop);
      }
      this.pararSpinner();
    }, 300);
  }

  private goSection(sectionId: any, selector: Element, marginTop: number) {
    this.router.navigate([], {fragment: '/' + sectionId});
    selector.scrollIntoView({block: 'start'});
    window.scrollBy(0, -marginTop);
  }

  onCotacaoOnlineClick(tipo: string) {
    this.iniciarSpinner();
    setTimeout(() => {
      if (this.tiposSeguros.RESIDENCIAL === tipo) {
        this.urlFrame = `https://porto.vc/residencia_essencial_4fe5bcf84da64a009f10ddd9c72934df`;
        window.open(this.urlFrame, '_blank');
        this.pararSpinner();
        return;
      } else if (this.tiposSeguros.AUTO === tipo) {
        this.urlFrame = `https://wwws.portoseguro.com.br/vendaonline/home.ns?cod=29db68682e8a46bf9280fd0066523519&utm_source=49017J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS`;
        window.open(this.urlFrame, '_blank');
        this.pararSpinner();
        return;
      } else if (this.tiposSeguros.VIDA === tipo) {
        this.urlFrame = `https://wwws.portoseguro.com.br/vendaonline/vidamaissimples/home.ns?cod=a8392b88d7ba4ea7a7494acb79082a60&utm_campaign=GeradordeLinks_CM22GJ&utm_content=GEIA_CORRETORA_DE_SEGUROS&origem=`;
        window.open(this.urlFrame, '_blank');
        this.pararSpinner();
        return;
      }
      this.pararSpinner();
    }, 1000);
  }

  verificarEstiloPortal(): string {
    if (this.router.url.includes('portal')) return 'estilo-portal';
    else return '-';
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
